import Vue from 'vue'
import Router from 'vue-router'
import Fabric from '../components/Fabric'
import Login from '../components/Login'
import Register from '../components/Register'
import Overview from '../components/Overview'
import NotFound from '../components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Overview',
      component: Overview
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/fabric',
      name: 'NewFabric',
      component: Fabric
    },
    {
      path: '/fabrics/:articleId',
      name: 'Fabric',
      component: Fabric
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js